import { render, staticRenderFns } from "./ElacCardTitle.vue?vue&type=template&id=1873f914&scoped=true"
import script from "./ElacCardTitle.vue?vue&type=script&lang=js"
export * from "./ElacCardTitle.vue?vue&type=script&lang=js"
import style0 from "./ElacCardTitle.vue?vue&type=style&index=0&id=1873f914&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873f914",
  null
  
)

export default component.exports